import React, { useEffect, useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import { ACCOUNTSTATEMENTS_QUERY } from 'features/accountStatement/list/queries';
import { ServiceContext } from 'providers/ServiceProvider';
import { Card } from '@totalsoft/rocket-ui';
import { useApolloClient } from '@apollo/client';
import { getListBrowserStore } from '@ts-private/list-browser';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { useMemo } from 'react';
import TableListBrowser from 'features/common/components/table-list-browser/TableListBrowser';
import ApolloFetchingComponent from 'features/common/components/apollo-fetching/ApolloFetchingComponent';
import AccountStatementItem from './AccountStatementItem';

export const accountStatementListBrowserTransitionsStore = getListBrowserStore({
  filterDefinitions: [
    {
      name: 'configName',
      caption: 'AccountStatement.ConfigurationName',
      type: 'text'
    },
    {
      name: 'activeYN',
      caption: 'AccountStatement.ActiveYN',
      type: 'boolean'
    }
  ],
  orderByFields: [
    {
      caption: 'AccountStatement.ConfigurationName',
      value: 'ConfigName'
    }
  ],
  pager: {
    orderBy: 'ConfigName',
    direction: 'asc'
  }
});

const AccountStatementListBrowser = ({canWrite}) => {
  const client = useApolloClient();
  const [activeService] = useContext(ServiceContext);

  const fetchingOptions = useMemo(
    () => ({
      queryOptions: {
        query: ACCOUNTSTATEMENTS_QUERY,
        name: 'accountStatements'
      }
    }),
    []
  );

  useEffect(() => {
    if (activeService) {
      client.cache.evict({ id: 'ROOT_QUERY', fieldName: 'accountStatements' });
      client.cache.gc();
    }
  }, [activeService, client]);

  const columns = useMemo(
    () => [
      { name: 'ConfigName', caption: 'AccountStatement.ConfigurationName' },
      { name: 'ConfigVersion', caption: 'AccountStatement.ConfigVersion' },
      { name: 'ActiveYN', caption: 'AccountStatement.ActiveYN', width: 5 },
      { name: 'actions', caption: 'Actions', width: '120px' }
    ],
    []
  );

  const itemComponent = useCallback(({ data }) => <AccountStatementItem data={data} canWrite={canWrite} />, [canWrite]);

  return (
    <Card icon={ListAltIcon}>
      <TableListBrowser
        name='automatic-state-transitions-browser'
        store={accountStatementListBrowserTransitionsStore}
        ItemComponent={itemComponent}
        columns={columns}
      />
      <ApolloFetchingComponent store={accountStatementListBrowserTransitionsStore} options={fetchingOptions} />
    </Card>
  );
};

AccountStatementListBrowser.propTypes = {
  canWrite: PropTypes.bool.isRequired
};

export default AccountStatementListBrowser;
